import GameDashboard from './GameDashboard';

export default GameDashboard;

